import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useBreakpoints } from 'hooks';
import { pick } from 'lodash';

import { CardsGrid, navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import { DevelopmentStages } from '../components/DevelopmentStages';
import { LargeCard } from '../components/LargeCard';
import { icons } from '../components/LargeCard/LargeCard';
import { ISectionVariant } from '../components/LargeCard/types';

import styles from './AboutTheProjectSection.module.scss';

export const AboutTheProjectSection: React.FC = () => {
  const { data } = useDataContext();
  const { isMobile } = useBreakpoints();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.aboutProject);

  const sectionData = pick(data, [
    'projectBriefDescription',
    'projectStatus',
    'mainGoals',
    'problemOfMarket',
    'strategyForAchievingGoals',
  ]);

  if (!hasMeaningfulValues(sectionData)) {
    return null;
  }

  const cardsList = [
    {
      title: t('onePageMapping.descriptionProject'),
      content: data.projectBriefDescription,
      icon: icons.description,
    },
    {
      title: t('onePageMapping.mainGoalsObjectives'),
      content: data.mainGoals,
      icon: icons.goals,
    },
    {
      title: t('onePageMapping.problemDefinition'),
      content: data.problemOfMarket,
      icon: icons.problemDefinition,
    },
    {
      title: t('onePageMapping.contributionToProblem'),
      content: data.strategyForAchievingGoals,
      icon: icons.problemSolving,
    },
  ].filter((el) => Boolean(el.content));

  const rangeVariant: ISectionVariant[] = ['primary', 'secondary', 'primary'];
  const chessVariant: ISectionVariant[] = ['primary', 'secondary', 'secondary', 'primary'];
  const mobileVariant: ISectionVariant[] = [
    'primary',
    'secondary',
    'primary',
    'secondary',
    'primary',
    'secondary',
    'primary',
    'secondary',
    'primary',
    'secondary',
  ];

  const currVariant = isMobile ? mobileVariant : cardsList.length % 4 === 0 ? chessVariant : rangeVariant;

  return (
    <Box {...registerNavSection} className={styles.section}>
      <Box className={styles.wrapper}>
        <Box component="h2" className={styles.title}>
          {t('aboutThe')}
          {t('project')}
        </Box>
        {data.projectStatus && <DevelopmentStages selectedStage={data.projectStatus} />}
        <CardsGrid>
          {cardsList.map((card, i) => (
            <LargeCard {...card} key={card.title} variant={currVariant[i]} className={styles.itemCard} />
          ))}
        </CardsGrid>
      </Box>
    </Box>
  );
};
